import React from 'react';
import { Card } from 'react-bootstrap';
import { CgMenuGridR } from "react-icons/cg";
import { IoMenuSharp } from "react-icons/io5";
import FilterSearch from '../FilterSearch';
import './SearchParts.css';

const SearchParts = () => {

    return (
        <Card className='area-filter-search'>
            <Card.Body >
                <FilterSearch />
            </Card.Body>
        </Card>)
}

export default SearchParts